import _extends from "@babel/runtime/helpers/extends";
import { Box, Button } from '@wix/design-system';
import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { ExternalLinkSmall } from '@wix/wix-ui-icons-common';
export const ConsentButtons = _ref => {
  let {
    shouldOpenInstallerInNewTab,
    onAgreeButtonClick,
    onCloseButtonClick,
    dataHook
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Box, {
    align: "right"
  }, /*#__PURE__*/React.createElement(Box, {
    marginRight: "12px"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    onClick: onCloseButtonClick,
    priority: "secondary",
    dataHook: `${dataHook}-cancel-button`
  }, t('user-consent.agree-and-add.secondary-cta'))), /*#__PURE__*/React.createElement(Button, _extends({
    size: "small",
    onClick: onAgreeButtonClick
  }, shouldOpenInstallerInNewTab ? {
    suffixIcon: /*#__PURE__*/React.createElement(ExternalLinkSmall, null)
  } : {}, {
    dataHook: `${dataHook}-agree-and-and-button`
  }), t('user-consent.agree-and-add.primary-cta')));
};
//# sourceMappingURL=ConsentButtons.js.map